export const REACT_APP_API_BASE_URL = process.env
  .REACT_APP_API_BASE_URL as string;

export const REACT_APP_TRIPOS_API_BASE_URL = process.env
  .REACT_APP_TRIPOS_API_BASE_URL as string;

export const REACT_APP_BASENAME = process.env.REACT_APP_BASENAME as string;
